import { Injectable } from '@angular/core';
import { ApiService } from './helpers/api.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class SearchService {
  private subject = new Subject<any>();
  constructor(private http: ApiService) {}
  search(link: string, data: any): Observable<any> {
    return this.http.get(`/api/v1/${link}?`, data).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  sendData(data: any) {
    this.subject.next(data);
  }

  getData(): Observable<any> {
    return this.subject.asObservable();
  }
}
